// @mui
import { useEffect, useState } from 'react';

import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import LoginDeailsService from '../../services/logindetails.service';

// ----------------------------------------------------------------------



export default function Footer() {
    const theme = useTheme();
    const [userData, setUserData] = useState([]);

    useEffect(() => {
        // Get upload rows
        LoginDeailsService.CallLoginAPI()
            .then((response) => {
                if (response.status === 200) {
                    setUserData(response.data);
                }
                else {
                   
                     //  console.log("error");

                }
            })
            .catch(error => {
               
                 //  console.log("in catch", error);

        
            });
    }, []);
    return (
        <Box
            sx={{
                backgroundColor: '#fff',
                color: theme.palette.primary.contrastText,
                py: 0.5,
                position: 'fixed',
                bottom: 0,
                width: '100%',
                padding: 0,
                zIndex: theme.zIndex.appBar + 2,
                maxHeight: '4vh',
                height: '4vh',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Typography
                variant="caption"
                color="#000000"
                sx={{
                    paddingLeft: '4px',
                    fontSize: '2vh',
                    '@media (max-width: 450px)': {
                        fontSize: '1.6vh',
                    },
                }}
            >
                {userData.footer}
            </Typography>
        </Box>

    );
}
